import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

export const FormGroup = ({ rendering }) => {
  return (
    <div className="vds-form__group">
      <Placeholder name="formGroup-content" rendering={rendering} />
    </div>
  );
};

export default FormGroup;
